import {useEffect, useState} from "react";
import {useProfile} from "@brg/auth";
import {API, Endpoints} from "@brg/api";
import {IPollInfo} from "../../constants/IPollInfo";

export const useGetPollByParentEntity = (projectId: string, t?: number) => {
        const [resp, setResp] = useState<IPollInfo | undefined>(undefined);
        const [isLoading, setIsLoading] = useState(true);
        const [error, setError] = useState(false);
        const profile = useProfile();

        useEffect(() => {
            if (projectId) {
                setIsLoading(true);
                API.request()
                    .endpoint(Endpoints.geograffee)
                    .url('/api/pools/GetByParentEntity')
                    .addQuery('parentEntityId', projectId)
                    .addQuery('parentEntityType', 'project')
                    .get()
                    .send()
                    .then((r) => r.json())
                    .then((r) => {
                        setResp(r?.pollData);
                        setIsLoading(false);
                    })
                    .catch((err) => setError(err));
            }
        }, [profile?.accountId, projectId, t])

        return {resp, isLoading, error};
}import {useEffect, useState} from "react";
import {useProfile} from "@brg/auth";
import {API, Endpoints} from "@brg/api";
import {IPollInfo} from "../../constants/IPollInfo";

export const useGetPollByParentEntity = (projectId: string, t?: number) => {
        const [resp, setResp] = useState<IPollInfo | undefined>(undefined);
        const [isLoading, setIsLoading] = useState(true);
        const [error, setError] = useState(false);
        const profile = useProfile();

        useEffect(() => {
            if (projectId) {
                setIsLoading(true);
                API.request()
                    .endpoint(Endpoints.geograffee)
                    .url('/api/pools/GetByParentEntity')
                    .addQuery('parentEntityId', projectId)
                    .addQuery('parentEntityType', 'project')
                    .get()
                    .send()
                    .then((r) => r.json())
                    .then((r) => {
                        setResp(r?.pollData);
                        setIsLoading(false);
                    })
                    .catch((err) => setError(err));
            }
        }, [profile?.accountId, projectId, t])

        return {resp, isLoading, error};
}